import { Action, combineReducers } from 'redux';

import { ContentExplorerState, ContentState, SelectionState } from '../../state/ContentExplorerState';
import { contentCountsReducer } from './ContentCountsReducer';
import { contentFetchBusyReducer } from './ContentFetchBusyReducer';
import { contentReducer } from './ContentReducer';
import { contentTypeFilterValuesReducer } from './ContentTypeReducer';
import { metricsDataCacheReducer } from './MetricsDataCacheReducer';
import { mixedContentFilterReducer } from './MixedContentFilterReducer';
import { recommendationTypeReducer } from './RecommendationTypeReducer';
import { selectedItemsReducer } from './SelectedItemsReducer';
import { selectionBusyReducer } from './SelectionBusyReducer';
import { showWorkbooksAsViewsReducer } from './ShowWorkbooksAsViewsReducer';

export const contentExplorerReducer: (
  previousState: ContentExplorerState,
  action: Action
) => ContentExplorerState = combineReducers<ContentExplorerState>(
  {
    content: combineReducers<ContentState>({
      contentItems: contentReducer,
      isBusy: contentFetchBusyReducer
    }),
    contentCounts: contentCountsReducer,
    contentTypeFilterValues: contentTypeFilterValuesReducer,
    mixedContentFilterClauses: mixedContentFilterReducer,
    selection: combineReducers<SelectionState>({
      selectedItems: selectedItemsReducer,
      isBusy: selectionBusyReducer
    }),
    showWorkbooksAsViews: showWorkbooksAsViewsReducer,
    recommendationType: recommendationTypeReducer,
    metricsDataCache: metricsDataCacheReducer,
  }
);
